import { render, staticRenderFns } from "./DictDeleteList.vue?vue&type=template&id=4b082415&scoped=true"
import script from "./DictDeleteList.vue?vue&type=script&lang=js"
export * from "./DictDeleteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b082415",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b082415')) {
      api.createRecord('4b082415', component.options)
    } else {
      api.reload('4b082415', component.options)
    }
    module.hot.accept("./DictDeleteList.vue?vue&type=template&id=4b082415&scoped=true", function () {
      api.rerender('4b082415', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/DictDeleteList.vue"
export default component.exports